import * as actionTypes from '../../../types/users';
import {
  getUserData,
  createUser,
  updateUserData,
  setUserPasswordUrl,
  changeUserStatusUrl,
  massChangeStatusesUrl,
  massCopyRatesUrl,
  massResetRatesUrl,
  getUsersCustomRatesUrl,
  copyCustomRatesUrl,
  makeExportUrl,
  getCustomRatesForUser,
  updateCustomRates,
  getExportListUrl,
  getActivityLog,
  getSignInHistory,
  updateDiscount,
} from '../../../../services/endpoints/users';
import { getServicesList } from '../../../../services/endpoints/general';

/**
 * @function
 * @name getUserDataAction
 * @description Получение данных по конкретному пользователю
 * @param {number} id
 */
export const getUserDataAction = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_DATA });

  try {
    const response = await getUserData(id);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({ type: actionTypes.GET_DATA_ERROR, error });
    throw error;
  }
};

/**
 * @function
 * @name onUpdateUserDataAction
 * @description Обновление данных по конкретному пользователю
 * @param {number} id
 * @param {Array} payload
 */
export const onUpdateUserDataAction = (id, payload) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_DATA });

  try {
    const response = await updateUserData(id, payload);
    const { data } = response;

    dispatch({
      type: actionTypes.UPDATE_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({ type: actionTypes.UPDATE_DATA_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name onCreateUserAction
 * @description Создание пользователя
 * @param {Array} payload
 */
export const onCreateUserAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_USER });

  try {
    const response = await createUser(payload);
    const data = { response };

    dispatch({
      type: actionTypes.CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({ type: actionTypes.CREATE_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name onChangeUserStatus
 * @description Смена статуса пользователя
 * @param {number} id
 * @param {Array} status
 */
export const onChangeUserStatus = (id, status) => async (dispatch) => {
  dispatch({ type: actionTypes.CHANGE_STATUS });

  try {
    const response = await changeUserStatusUrl(id, status);
    const { data } = response;
    dispatch({
      type: actionTypes.CHANGE_STATUS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({ type: actionTypes.CHANGE_STATUS_ERROR, error });
  }
};

/**
 * @function
 * @name onCopyCustomRates
 * @description Копирование рейтсов
 * @param {number} from
 * @param {number} to
 */
export const onCopyCustomRates = (from, to) => async (dispatch) => {
  dispatch({ type: actionTypes.COPY_CUSTOM_RATES });

  try {
    await copyCustomRatesUrl(from, to);
    dispatch({ type: actionTypes.COPY_CUSTOM_RATES_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.COPY_CUSTOM_RATES_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name onSetUserPassword
 * @description Создание пароля для пользователя
 * @param {number} id
 * @param {number} password
 */
export const onSetUserPassword = (id, password) => async (dispatch) => {
  dispatch({ type: actionTypes.SET_PASSWORD });

  try {
    await setUserPasswordUrl(id, password);
    dispatch({ type: actionTypes.SET_PASSWORD_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.SET_PASSWORD_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name onClearUserData
 * @description Очистка стейта
 */
export const onClearUserData = () => (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_DATA });
};

/**
 * @function
 * @name onMassChangeStatus
 * @description Массовая смена статусов
 * @param {number} status
 * @param {Array} users
 */
export const onMassChangeStatus = (status, users) => async (dispatch) => {
  dispatch({ type: actionTypes.MASS_CHANGE_STATUS });

  try {
    await massChangeStatusesUrl(status, users);
    dispatch({ type: actionTypes.MASS_CHANGE_STATUS_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.MASS_CHANGE_STATUS_ERROR, error });
  }
};

/**
 * @function
 * @name onMassResetRates
 * @description Массовый сброс статусов
 * @param {Array} users
 */
export const onMassResetRates = (users) => async (dispatch) => {
  dispatch({ type: actionTypes.MASS_RESET_RATES });

  try {
    await massResetRatesUrl(users);
    dispatch({ type: actionTypes.MASS_RESET_RATES_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.MASS_RESET_RATES_ERROR, error });
  }
};

/**
 * @function
 * @name onMassCopyRates
 * @description Массовое копирование рейтсов
 * @param {Array} fromUser
 * @param {Array} toUsers
 */
export const onMassCopyRates = (fromUser, toUsers) => async (dispatch) => {
  dispatch({ type: actionTypes.MASS_COPY_RATES });

  try {
    await massCopyRatesUrl(fromUser, toUsers);
    dispatch({ type: actionTypes.MASS_COPY_RATES_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.MASS_COPY_RATES_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name getUsersCustomRates
 * @description Получение всех рейтсов
 */
export const getUsersCustomRates = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_WITH_CUSTOM_RATES });

  try {
    const response = await getUsersCustomRatesUrl();
    const { data } = response;
    const { users } = data;

    dispatch({
      type: actionTypes.GET_WITH_CUSTOM_RATES_SUCCESS,
      payload: users,
    });
  } catch (error) {
    dispatch({ type: actionTypes.GET_WITH_CUSTOM_RATES_ERROR, error });
  }
};

/**
 * @function
 * @name getCustomRatesForUserAction
 * @description Получение рейтсов для пользователя
 * @param {number} id
 */
export const getCustomRatesForUserAction = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_CUSTOM_RATES_FOR_USER });

  try {
    const response = await getCustomRatesForUser(id);
    const { data } = response;
    const { rates, user } = data;

    dispatch({
      type: actionTypes.GET_CUSTOM_RATES_FOR_SUCCESS,
      rates,
      user,
      ratesUserId: id,
    });
  } catch (error) {
    dispatch({ type: actionTypes.GET_CUSTOM_RATES_FOR_ERROR, error });
    throw error;
  }
};

/**
 * @function
 * @name getServicesListAction
 * @description Получение списка сервисов
 */
export const getServicesListAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_SERVICES_LIST });

  try {
    const response = await getServicesList();
    const { data } = response;
    const { categories } = data;

    dispatch({
      type: actionTypes.GET_SERVICES_LIST_SUCCESS,
      data: categories,
    });
  } catch (error) {
    dispatch({ type: actionTypes.GET_SERVICES_LIST_ERROR, error });
    throw error;
  }
};

/**
 * @function
 * @name onUpdateCustomRatesAction
 * @description Обновление рейтсов для пользователя
 * @param {number} id
 * @param {Array} payload
 */
export const onUpdateCustomRatesAction = (id, payload) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_CUSTOM_RATES });

  try {
    await updateCustomRates(id, payload);

    dispatch({
      type: actionTypes.UPDATE_CUSTOM_RATES_SUCCESS,
    });
  } catch (error) {
    dispatch({ type: actionTypes.UPDATE_CUSTOM_RATES_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name getExportList
 * @description Список экспортов
 * @param {object} payload
 */
export const getExportList = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_EXPORT_LIST });

  try {
    const response = await getExportListUrl(payload);
    const { data } = response;
    dispatch({
      type: actionTypes.GET_EXPORT_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({ type: actionTypes.GET_EXPORT_LIST_ERROR, error });
  }
};

/**
 * @function
 * @name onMakeExport
 * @description Создание файла для экспорта
 * @param {object} payload
 */
export const onMakeExport = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.MAKE_EXPORT });

  try {
    await makeExportUrl(payload);
    dispatch({ type: actionTypes.MAKE_EXPORT_SUCCESS });
  } catch (error) {
    dispatch({ type: actionTypes.MAKE_EXPORT_ERROR, error });
    if (error?.data?.error_message) {
      throw error.data.error_message;
    }
  }
};

/**
 * @function
 * @name getActivityLogAction
 * @description Активность пользователя
 * @param {number} id
 */
export const getActivityLogAction = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_ACTIVITY_LOG });

  try {
    const response = await getActivityLog(id);
    const { data } = response;

    dispatch({ type: actionTypes.GET_ACTIVITY_LOG_SUCCESS, data: data.logs });
  } catch (error) {
    dispatch({ type: actionTypes.GET_ACTIVITY_LOG_ERROR, error });
  }
};

/**
 * @function
 * @name getSignInHistoryAction
 * @description История пользователя
 * @param {number} id
 * @param {Array} payload
 */
export const getSignInHistoryAction = (id, payload) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_SIGNIN_HISTORY });

  try {
    const response = await getSignInHistory(id, payload);
    const { data } = response;
    data.userId = id;

    dispatch({ type: actionTypes.GET_SIGNIN_HISTORY_SUCCESS, data });
  } catch (error) {
    dispatch({ type: actionTypes.GET_SIGNIN_HISTORY_ERROR, error });
  }
};

/**
 * @function
 * @name onUpdateDiscountAction
 * @description Обновление скидки пользователя
 * @param {number} id
 * @param {String} discount
 */
export const onUpdateDiscountAction = (id, discount) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_DISCOUNT });

  try {
    await updateDiscount(id, discount);

    dispatch({
      type: actionTypes.UPDATE_DISCOUNT_SUCCESS,
    });
  } catch (error) {
    dispatch({ type: actionTypes.UPDATE_DISCOUNT_ERROR, error });
  }
};
